import { InputLeftAddon, InputRightAddon } from '@chakra-ui/react';

import InputFormikField from '../forms/InputFormikField';
import DateFormikField from '../forms/DateFormikField';
import NumberInputFormikField from '../forms/NumberInputFormikField';
import ComboboxFormikField from '../forms/ComboboxFormikField';
import ProgressBarFormikField from '../forms/ProgressBarFormikField';
import CheckboxFormikField from '../forms/CheckboxFormikField';

const AutoformInputFormikField = ({
    inputType,
    inputName,
    inputLabel,
    dataType,
    dropdownOptions,
    inputPlaceholder,
    settings,
    isDisabled,
    formats,
    ...rest
}) => {
    const numberField = (
        <NumberInputFormikField
            id={inputName}
            name={inputName}
            label={inputLabel}
            placeholder={inputPlaceholder}
            isDisabled={isDisabled}
            step={settings?.NUDSTEP}
            max={settings?.NUDMAX}
            min={settings?.NUDMIN}
            info={settings?.CELLTOOLTIP}
            leftElement={
                formats.numberFormat === 'currency' && (
                    <InputLeftAddon pointerEvents="none" color="gray.300" fontSize="1.2em" children="$" mr={1} />
                )
            }
            rightElement={formats.numberFormat === 'percent' && <InputRightAddon children="%" ml={1} />}
        />
    );
    switch (inputType) {
        case 'ComboBox':
            return (
                <ComboboxFormikField
                    id={inputName}
                    name={inputName}
                    label={inputLabel}
                    options={dropdownOptions}
                    valueKey="value"
                    labelKey="text"
                    info={settings?.CELLTOOLTIP}
                    isDisabled={isDisabled}
                />
            );
        case 'CheckBox':
            return (
                <CheckboxFormikField
                    id={inputName}
                    name={inputName}
                    label={inputLabel}
                    info={settings?.CELLTOOLTIP}
                    isDisabled={isDisabled}
                >
                    {inputLabel}
                </CheckboxFormikField>
            );
        case 'NumericUpDown':
            return numberField;
        case 'MonthCalendar':
            return (
                <DateFormikField
                    id={inputName}
                    name={inputName}
                    label={inputLabel}
                    placeholder={inputPlaceholder}
                    info={settings?.CELLTOOLTIP}
                    isDisabled={isDisabled}
                    dateFormat={formats.dateFormat}
                />
            );
        case 'ProgressBar':
            return <ProgressBarFormikField id={inputName} name={inputName} label={inputLabel} />;
        default:
            return dataType === 'System.Int32' || dataType === 'System.Double' ? (
                numberField
            ) : (
                <InputFormikField
                    id={inputName}
                    name={inputName}
                    label={inputLabel}
                    isDisabled={isDisabled}
                    placeholder={inputPlaceholder}
                    info={settings?.CELLTOOLTIP}
                />
            );
    }
};

export default AutoformInputFormikField;
